<template>
    <main>

        <HomeBanner />

        <!-- feature-area-start -->
        <div class="it-feature-area grey-bg it-feature-2-style pt-120 pb-120">
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                        <div class="it-feature-item text-center">
                            <div class="it-feature-item-content z-index">
                                <div class="it-feature-icon">
                                    <span><i class="flaticon-class"></i></span>
                                </div>
                                <div class="it-feature-text pt-30">
                                    <h4 class="it-feature-title">SPECIALISATION OFFERED</h4>
                                    <p>Tailor Your MBA Journey with In-Demand Specializations Designed for Today's
                                        Business Landscape</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                        <div class="it-feature-item text-center">
                            <div class="it-feature-item-content z-index">
                                <div class="it-feature-icon">
                                    <span><i class="flaticon-bachelor"></i></span>
                                </div>
                                <div class="it-feature-text pt-30">
                                    <h4 class="it-feature-title">EXPERT TEACHERS</h4>
                                    <p>Learn from experienced faculty, industry experts, and renowned academic leaders
                                        dedicated to your success.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
                        <div class="it-feature-item text-center">
                            <div class="it-feature-item-content z-index">
                                <div class="it-feature-icon">
                                    <span><i class="flaticon-study"></i></span>
                                </div>
                                <div class="it-feature-text pt-30">
                                    <h4 class="it-feature-title">INDUSTRY EXPOSURE</h4>
                                    <p>Gain real-world experience through internships, live projects, and industry
                                        interactions.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- feature-area-end -->

        <!-- about-area-start -->
        <div class="it-about-2-area p-relative pt-120 pb-120">
            <div class="it-about-2-shape-2 d-none d-xxl-block">
            </div>
            <div class="it-about-2-big-text">
                <h6>ABOUT US</h6>
            </div>
            <div class="container">
                <div class="row align-items-end">
                    <div class="col-xl-6 col-lg-6 order-1 order-lg-0">
                        <div class="it-about-2-thumb-wrap d-flex justify-content-between">
                            <div class="it-about-2-thumb p-relative mt-95">
                                <img src="/img/about/M1.png" alt="">
                            </div>
                            <div class="it-about-2-thumb">
                                <img src="/img/about/M2.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 order-0 order-lg-1">
                        <div class="it-about-2-right">
                            <div class="it-about-2-title-box pb-25">
                                <span class="it-section-subtitle-2">About us</span>
                                <h4 class="it-section-title">Transform Your Career with a Purpose-Driven MBA/MMS
                                </h4>
                            </div>
                            <div class="it-about-2-text pb-5">
                                <p>Our MMS curriculum aligns with industry needs, combining core management principles
                                    with emerging business trends. With experienced faculty, modern infrastructure, and
                                    a learner-focused approach, we foster critical thinking, innovation, and leadership.
                                    Students benefit from a collaborative environment, real-world insights, and
                                    opportunities to turn ideas into action.</p>
                            </div>
                            <div class="it-about-2-text-2 mb-30">
                                <span>What You’ll Gain:</span>
                            </div>
                            <div class="it-about-2-bottom d-flex justify-content-between align-items-end">
                                <div class="it-about-2-icon-wrap">
                                    <div class="it-about-2-icon mb-15 d-flex align-items-center">
                                        <img src="/img/about/icon-1-2.png" alt="">
                                        <span>Leadership & Strategic Thinking Skills</span>
                                    </div>
                                    <div class="it-about-2-icon mb-15 d-flex align-items-center">
                                        <img src="/img/about/icon-1-2.png" alt="">
                                        <span>Global Business Perspective</span>
                                    </div>
                                    <div class="it-about-2-icon mb-15 d-flex align-items-center">
                                        <img src="/img/about/icon-1-2.png" alt="">
                                        <span>Access to Industry Mentors and Career Coaches</span>
                                    </div>
                                    <div class="it-about-2-icon mb-15 d-flex align-items-center">
                                        <img src="/img/about/icon-1-2.png" alt="">
                                        <span>Real-World Learning via Internships and Projects</span>
                                    </div>
                                    <router-link class="it-btn-white sky-bg" to="/about">
                                        <span>
                                            More About Us
                                            <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                                    stroke-miterlimit="10" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- about-area-end -->

        <!-- cta-area-start -->
        <div class="it-cta-area it-cta-height black-bg p-relative">
            <div class="it-cta-bg d-none d-xl-block">
                <img src="/img/about/M3.png" alt="">
            </div>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-9 col-lg-7 col-md-7">
                        <div class="it-cta-content">
                            <h4 class="it-cta-title">Take the Next Step Toward Your Bright Future</h4>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-5 col-md-5">
                        <div class="it-cta-button text-md-end">
                            <router-link class="it-btn-white sky-bg" to="/contact">
                                <span>
                                    Contact Us
                                    <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- cta-area-end -->

        <!-- course-area-start -->
        <div class="it-course-area it-course-style-2  p-relative pt-120 pb-120">
            <div class="it-course-shape-6 d-none d-xl-block">
            </div>
            <div class="container">
                <div class="it-course-title-wrap p-relative mb-60">
                    <div class="it-course-shape-5 d-none d-xl-block">
                        <img src="/img/course/shape-1-5.png" alt="">
                    </div>
                    <div class="row align-items-end">
                        <div class="col-xl-8 col-lg-8 col-md-8">
                            <div class="it-course-title-box">
                                <span class="it-section-subtitle-2">Our Courses</span>
                                <h4 class="it-section-title">
                                    Creating A Community Of <br>
                                    Life Long Learners.
                                </h4>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div class="it-course-button text-start text-md-end">
                                <router-link class="it-btn-white sky-bg" to="/courses">
                                    <span>
                                        Our Courses
                                        <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-lg-6">
                        <div class="it-course-2-wrap d-flex align-items-center">
                            <div class="it-course-thumb  p-relative">
                                <a class="fix" href="#"><img src="/img/course/C1.png" alt=""></a>
                                <div class="it-course-thumb-text">
                                    <span>Bachelor</span>
                                </div>
                            </div>
                            <div class="it-course-content">
                                <h4 class="it-course-title pb-15"><a href="#">Bachelor of Management
                                        Studies (BMS)</a></h4>
                                <div class="it-course-info pb-20 mb-25 d-flex justify-content-between">
                                    <span><i class="fa-light fa-file-invoice"></i>Regular</span>
                                    <span><i class="fa-sharp fa-regular fa-clock"></i>3 years course</span>
                                    <span><i class="fa-light fa-user"></i>60 Seats</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="it-course-2-wrap d-flex align-items-center">
                            <div class="it-course-thumb  p-relative">
                                <a href="#"><img src="/img/course/C2.png" alt=""></a>
                                <div class="it-course-thumb-text">
                                    <span>Master</span>
                                </div>
                            </div>
                            <div class="it-course-content">
                                <h4 class="it-course-title pb-15"><a href="#">Master of Management
                                        Studies (MMS)</a></h4>
                                <div class="it-course-info pb-20 mb-25 d-flex justify-content-between">
                                    <span><i class="fa-light fa-file-invoice"></i>Regular</span>
                                    <span><i class="fa-sharp fa-regular fa-clock"></i>2 years course</span>
                                    <span><i class="fa-light fa-user"></i>60 seats</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- course-area-end -->

        <!-- choose-area-start -->
        <div class="it-choose-area it-choose-style-2 z-index fix p-relative grey-bg pt-180 pb-110">
            <div class="it-choose-shape-5 d-none d-xl-block">
                <img src="/img/choose/shape-1-7.png" alt="">
            </div>
            <div class="it-choose-shape-6 d-none d-xl-block">
            </div>
            <div class="it-choose-shape-7 d-none d-xl-block">
            </div>
            <div class="it-choose-shape-8 d-none d-xl-block">
                <img src="/img/choose/shape-1-10.png" alt="">
            </div>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-6 col-lg-6 mb-30">
                        <div class="it-choose-thumb-box text-center text-lg-end">
                            <div class="it-choose-thumb p-relative">
                                <img src="/img/choose/bldg.png" alt="">
                                <div class="it-choose-shape-1">
                                    <img src="/img/choose/shape-1-5.png" alt="">
                                </div>
                                <div class="it-choose-shape-2">
                                    <img src="/img/choose/shape-1-6.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 mb-30">
                        <div class="it-choose-left">
                            <div class="it-choose-title-box mb-30">
                                <span class="it-section-subtitle-2">WHY CHOOSE US</span>
                                <h4 class="it-section-title">Achievers Edge
                                </h4>
                            </div>
                            <div class="it-choose-content-box">
                                <div class="it-choose-content d-flex align-items-center mb-30">
                                    <div class="it-choose-icon">
                                        <span><i class="flaticon-skill"></i></span>
                                    </div>
                                    <div class="it-choose-text">
                                        <h4 class="it-choose-title">AICTE Entitled Degree</h4>
                                        <p class="mb-0">An AICTE Entitled MBA gives you the credibility, confidence, and
                                            competitive edge to succeed in today’s dynamic business world.</p>
                                    </div>
                                </div>
                                <div class="it-choose-content d-flex align-items-center mb-30">
                                    <div class="it-choose-icon">
                                        <span><i class="flaticon-funds"></i></span>
                                    </div>
                                    <div class="it-choose-text">
                                        <h4 class="it-choose-title">Industry relevant curriculum</h4>
                                        <p class="mb-0">Our curriculum is designed in collaboration with industry
                                            leaders to ensure you're learning what matters most.</p>
                                    </div>
                                </div>
                                <div class="it-choose-content d-flex align-items-center mb-30">
                                    <div class="it-choose-icon">
                                        <span><i class="flaticon-funds"></i></span>
                                    </div>
                                    <div class="it-choose-text">
                                        <h4 class="it-choose-title">Monthly Master class with Industry Expert</h4>
                                        <p class="mb-0">Gain exclusive insights and strategies from top industry leaders
                                            each month.Stay inspired with real-world perspectives beyond the classroom.
                                        </p>
                                    </div>
                                </div>
                                <!-- <div class="it-choose-content d-flex align-items-center">
                                    <div class="it-choose-icon">
                                        <span><i class="flaticon-flexibility"></i></span>
                                    </div>
                                    <div class="it-choose-text">
                                        <h4 class="it-choose-title">Click to Know More...</h4>                                       
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- choose-area-end -->

        <!-- testimonial-area-start -->
        <div class="it-testimonial-5-area it-testimonial-style-2 p-relative pt-120 pb-120">
            <div class="it-testimonial-5-shape-5 d-none d-xl-block">
            </div>
            <div class="it-testimonial-5-shape-6 d-none d-xl-block">
            </div>
            <div class="it-testimonial-5-shape-7 d-none d-xl-block">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="it-testimonial-5-title-box text-center mb-60">
                            <span class="it-section-subtitle-2">Testimonial</span>
                            <h4 class="it-section-title-5">A program that changes lives</h4>
                        </div>
                    </div>
                    <div class="col-xl-12">
                        <div class="it-testimonial-5-wrapper p-relative">
                            <div class="swiper-container it-testimonial-5-active">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="it-testimonial-5-item p-relative z-index">
                                            <div class="it-testimonial-3-author-box d-flex align-items-center mb-20">
                                                <div class="it-testimonial-3-avata">
                                                    <img src="/img/avatar/avatar-3-1.png" alt="">
                                                </div>
                                                <div class="it-testimonial-3-author-info">
                                                    <h5>Aisha Mehta, MBA Student</h5>
                                                    <span>Former BMS Graduate</span>
                                                </div>
                                            </div>
                                            <div class="it-testimonial-5-content z-index-5">
                                                <div class="it-testimonial-5-text">
                                                    <p>Joining the MBA program after my BMS was the best decision I made
                                                        for my career. The specialized courses gave me in-depth
                                                        knowledge beyond the basics, and the expert faculty made complex
                                                        topics easy to understand. The exposure to real-world case
                                                        studies and industry projects truly bridged the gap between
                                                        theory and practice. I feel more confident, capable, and ready
                                                        to take on leadership roles.</p>
                                                </div>
                                            </div>
                                            <div class="it-testimonial-5-quote d-none d-xl-block">
                                                <img src="/img/testimonial/quote-1-2.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- testimonial-area-end -->

        <!-- video-area-start -->
        <div class="it-video-area it-video-style-2 it-video-bg p-relative fix pt-100 pb-95"
            :style="{ backgroundImage: 'url(/img/video/M5.png)' }">
            <div class="it-video-shape-1 d-none d-lg-block">
                <img src="/img/video/shape-1-6.png" alt="">
            </div>
            <div class="it-video-shape-2 d-none d-lg-block">
                <img src="/img/video/shape-1-2.png" alt="">
            </div>
            <div class="it-video-shape-3 d-none d-lg-block">
            </div>
            <div class="it-video-shape-4 d-none d-lg-block">
            </div>
            <div class="it-video-shape-5 d-none d-lg-block">
            </div>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-7 col-lg-7 col-md-9 col-sm-9">
                        <div class="it-video-content">
                            <span>Join Our New Session</span>
                            <h3 class="it-video-title">Call To Enroll<br> <a href="tel:9619392909">(91)9619392909</a>
                            </h3>
                            <div class="it-video-button">
                                <router-link class="it-btn blue-bg" to="/contact">
                                    <span>
                                        Join With us
                                        <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-5 col-md-3 col-sm-3">
                        <div
                            class="it-video-play-wrap d-flex justify-content-start justify-content-md-end align-items-center">
                            <div class="it-video-play text-center">
                                <a class="popup-video play" href="#"><i class="fas fa-play"></i></a>
                                <a class="text" href="#">watch now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- video-area-end -->

        <!-- contact-area-start -->
        <div style="display: none;" class="it-contact-area it-contact-style-2 it-contact-bg p-relative pt-120 pb-120"
            data-background="/img/contact/bg-1-2.jpg">
            <div class="it-contact-shape-1 d-none d-xxl-block">
                <img src="/img/contact/shape-1-1.png" alt="">
            </div>
            <div class="it-contact-shape-3 z-index-5 d-none d-xxl-block">
                <img src="/img/contact/shape-1-6.png" alt="">
            </div>
            <div class="it-contact-shape-4 d-none d-xxl-block">
                <img src="/img/contact/shape-1-4.png" alt="">
            </div>
            <div class="it-contact-shape-5 d-none d-xxl-block">
                <img src="/img/contact/shape-1-7.png" alt="">
            </div>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-7 col-lg-6">
                        <div class="it-contact-left">
                            <div class="it-contact-title-box pb-20">
                                <span class="it-section-subtitle-2">
                                    Contact With US
                                </span>
                                <h2 class="it-section-title-3">Register Now Get Premium
                                    Online Admison</h2>
                            </div>
                            <div class="it-contact-text pb-15">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                    exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
                            </div>
                            <div class="it-contact-timer-box mb-40" data-countdown data-date="Sep 30 2024 20:20:22">
                                <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                                        <div class="it-contact-timer text-center">
                                            <h6 data-days>00</h6>
                                            <i>DAYS</i>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                                        <div class="it-contact-timer text-center">
                                            <h6 data-hours>00</h6>
                                            <i>HOURS</i>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                                        <div class="it-contact-timer text-center">
                                            <h6 data-minutes>00</h6>
                                            <i>MINUTES</i>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
                                        <div class="it-contact-timer text-center">
                                            <h6 data-seconds>00</h6>
                                            <i>SECONDS</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="it-contact-thumb-box">
                                <img src="/img/contact/thumb-1-1.jpg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-6">
                        <div class="it-contact-wrap" data-background="/img/contact/bg-5.jpg">
                            <h4 class="it-contact-title text-black">Search for courses</h4>
                            <p class="pb-15">Suspendisse ultrice gravida dictum fusce <br>
                                placerat ultricies integer</p>
                            <form action="#">
                                <div class="row">
                                    <div class="col-12 mb-15">
                                        <div class="it-contact-input-box">
                                            <input type="text" placeholder="Your Name">
                                        </div>
                                    </div>
                                    <div class="col-12 mb-15">
                                        <div class="it-contact-input-box">
                                            <input type="email" placeholder="Your Email">
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12 mb-15">
                                        <div class="it-contact-select mb-30">
                                            <select>
                                                <option>Instructor</option>
                                                <option>01 Year</option>
                                                <option>02 Year</option>
                                                <option>03 Year</option>
                                                <option>04 Year</option>
                                                <option>05 Year</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12 mb-15">
                                        <div class="it-contact-select mb-30">
                                            <select>
                                                <option>Department</option>
                                                <option>01 Year</option>
                                                <option>02 Year</option>
                                                <option>03 Year</option>
                                                <option>04 Year</option>
                                                <option>05 Year</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12 mb-15">
                                        <div class="it-contact-select mb-30">
                                            <select>
                                                <option>Campus</option>
                                                <option>01 Year</option>
                                                <option>02 Year</option>
                                                <option>03 Year</option>
                                                <option>04 Year</option>
                                                <option>05 Year</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12 mb-15">
                                        <div class="it-contact-select mb-30">
                                            <select>
                                                <option>Level</option>
                                                <option>01 Year</option>
                                                <option>02 Year</option>
                                                <option>03 Year</option>
                                                <option>04 Year</option>
                                                <option>05 Year</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <button type="submit" class="it-btn black-bg">
                                <span>
                                    submit now
                                    <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- contact-area-end -->

        <!-- event-area-start -->
        <div style="display: none;" class="it-event-2-area p-relative pt-90 pb-90">
            <div class="container">
                <div class="it-event-2-title-wrap mb-60">
                    <div class="row align-items-end">
                        <div class="col-12">
                            <div class="it-event-2-title-box text-center">
                                <span class="it-section-subtitle-2">
                                    Our Events
                                </span>
                                <h2 class="it-section-title-3">Upcoming Events</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6 mb-30">
                        <div class="it-event-2-item-box">
                            <div class="it-event-2-item">
                                <div class="it-event-2-thumb fix">
                                    <a href="#"><img src="/img/event/event-1-1.jpg" alt=""></a>
                                    <div class="it-event-2-date">
                                        <span><i>08</i> <br>
                                            October</span>
                                    </div>
                                </div>
                                <div class="it-event-2-content">
                                    <h4 class="it-event-2-title"><a href="#">print, and publishing
                                            industries
                                            for previewing</a></h4>
                                    <div class="it-event-2-text">
                                        <p class="mb-0 pb-10">Lorem ipsum dolor sit amet, consectetur elit, sed
                                            doeiusmod tempor
                                        </p>
                                    </div>
                                    <div class="it-event-2-meta">
                                        <span>
                                            <i class="fa-light fa-clock"></i>
                                            Time: 11:00am 03;00pm
                                        </span>
                                        <span>
                                            <a href="#">
                                                <i class="fa-light fa-location-dot"></i>
                                            </a>
                                            Location: USA
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 mb-30">
                        <div class="it-event-2-item-box">
                            <div class="it-event-2-item">
                                <div class="it-event-2-thumb fix">
                                    <a href="#"><img src="/img/event/event-1-2.jpg" alt=""></a>
                                    <div class="it-event-2-date">
                                        <span><i>05</i> <br>
                                            October</span>
                                    </div>
                                </div>
                                <div class="it-event-2-content">
                                    <h4 class="it-event-2-title"><a href="#">print, and publishing
                                            industries
                                            for previewing</a></h4>
                                    <div class="it-event-2-text">
                                        <p class="mb-0 pb-10">Lorem ipsum dolor sit amet, consectetur elit, sed
                                            doeiusmod tempor
                                        </p>
                                    </div>
                                    <div class="it-event-2-meta">
                                        <span>
                                            <i class="fa-light fa-clock"></i>
                                            Time: 11:00am 03;00pm
                                        </span>
                                        <span>
                                            <a href="#">
                                                <i class="fa-light fa-location-dot"></i>
                                            </a>
                                            Location: USA
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 mb-30">
                        <div class="it-event-2-item-box">
                            <div class="it-event-2-item">
                                <div class="it-event-2-thumb fix">
                                    <a href="#"><img src="/img/event/event-1-3.jpg" alt=""></a>
                                    <div class="it-event-2-date">
                                        <span><i>25</i> <br>
                                            April</span>
                                    </div>
                                </div>
                                <div class="it-event-2-content">
                                    <h4 class="it-event-2-title"><a href="#">print, and publishing
                                            industries
                                            for previewing</a></h4>
                                    <div class="it-event-2-text">
                                        <p class="mb-0 pb-10">Lorem ipsum dolor sit amet, consectetur elit, sed
                                            doeiusmod tempor
                                        </p>
                                    </div>
                                    <div class="it-event-2-meta">
                                        <span>
                                            <i class="fa-light fa-clock"></i>
                                            Time: 11:00am 03;00pm
                                        </span>
                                        <span>
                                            <a href="#">
                                                <i class="fa-light fa-location-dot"></i>
                                            </a>
                                            Location: USA
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- event-area-end -->

        <!-- brand-area-start -->
        <div style="display: none;" class="it-brand-area black-bg pt-50 pb-50">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="it-brand-wrapper">
                            <div class="swiper-container it-brand-active">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="it-brand-item text-center">
                                            <img src="/img/brand/brand-1-1.png" alt="">
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="it-brand-item text-center">
                                            <img src="/img/brand/brand-1-1.png" alt="">
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="it-brand-item text-center">
                                            <img src="/img/brand/brand-1-1.png" alt="">
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="it-brand-item text-center">
                                            <img src="/img/brand/brand-1-1.png" alt="">
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="it-brand-item">
                                            <img src="/img/brand/brand-1-1.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- brand-area-end -->

        <!-- faq-area-start -->
        <div style="display: none;" class="it-faq-area p-relative pt-120 pb-120">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-6 col-lg-6">
                        <div class="it-faq-thumb text-center text-lg-start">
                            <img src="/img/faq/faq-2.jpg" alt="">
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="it-faq-wrap">
                            <div class="it-faq-title-box mb-20">
                                <span class="it-section-subtitle-2">faq</span>
                                <h4 class="it-section-title-5">Frequently asked some
                                    questions?</h4>
                            </div>
                            <div class="it-custom-accordion it-custom-accordion-style-2">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-items tp-faq-active">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-buttons " type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                                Why do students prefer online learning?
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show"
                                            aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div class="accordion-body d-flex align-items-center">
                                                <p class="mb-0">Lorem ipsum dolor sit amet, consectetur elit, sed
                                                    doeiusmod tempor
                                                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                    veniam, quis
                                                    nostrud exercitation.</p>
                                                <img class="d-none d-xl-block" src="/img/faq/thumb-2.jpg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-items">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-buttons collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                aria-expanded="false" aria-controls="collapseTwo">
                                                Where should I study abroad?
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse"
                                            aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                            <div class="accordion-body d-flex align-items-center">
                                                <p class="mb-0">Lorem ipsum dolor sit amet, consectetur elit, sed
                                                    doeiusmod tempor
                                                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                    veniam, quis
                                                    nostrud exercitation.</p>
                                                <img class="d-none d-xl-block" src="/img/faq/thumb-2.jpg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-items">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-buttons collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="false" aria-controls="collapseThree">
                                                How can I contact a school directly?
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse"
                                            aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                            <div class="accordion-body d-flex align-items-center">
                                                <p class="mb-0">Lorem ipsum dolor sit amet, consectetur elit, sed
                                                    doeiusmod tempor
                                                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                    veniam, quis
                                                    nostrud exercitation.</p>
                                                <img class="d-none d-xl-block" src="/img/faq/thumb-2.jpg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-items">
                                        <h2 class="accordion-header" id="headingFour">
                                            <button class="accordion-buttons collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                aria-expanded="false" aria-controls="collapseFour">
                                                How do I find a school where I want to study?
                                            </button>
                                        </h2>
                                        <div id="collapseFour" class="accordion-collapse collapse"
                                            aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                            <div class="accordion-body d-flex align-items-center">
                                                <p class="mb-0">Lorem ipsum dolor sit amet, consectetur elit, sed
                                                    doeiusmod tempor
                                                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                                    veniam, quis
                                                    nostrud exercitation.</p>
                                                <img class="d-none d-xl-block" src="/img/faq/thumb-2.jpg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- faq-area-end -->

        <!-- blog-area-start -->
        <div style="display: none;" class="it-blog-area it-blog-style-3 grey-bg pt-90 pb-90">
            <div class="container">
                <div class="it-blog-title-wrap mb-60">
                    <div class="row align-items-end">
                        <div class="col-xl-8 col-lg-8 col-md-8">
                            <div class="it-blog-title-box">
                                <span class="it-section-subtitle-2">DIRECTLY FROM BLOG</span>
                                <h4 class="it-section-title">Our latest news & upcoming <br>
                                    blog posts
                                </h4>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div class="it-blog-button text-start text-md-end">
                                <a class="it-btn blue-bg" href="#">
                                    <span>
                                        all blog post
                                        <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 mb-30">
                        <div class="it-blog-item">
                            <div class="it-blog-thumb fix">
                                <a href="#"><img src="/img/blog/blog-1-7.jpg" alt=""></a>
                            </div>
                            <div class="it-blog-content">
                                <div class="it-blog-meta pb-25">
                                    <span>
                                        <i class="fa-light fa-user"></i>
                                        Sunilra smoth</span>
                                    <span>
                                        <i class="fa-light fa-calendar-days"></i>
                                        March 28, 2023</span>
                                </div>
                                <h4 class="it-blog-title pb-5"><a href="#">Lorem ipsum dolor sit amet,
                                        consectetur
                                        Adipiscing elit, sed do.</a></h4>
                                <a class="it-btn blue-bg" href="#">
                                    <span>
                                        read more
                                        <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 mb-30">
                        <div class="it-blog-item">
                            <div class="it-blog-thumb fix">
                                <a href="#"><img src="/img/blog/blog-1-8.jpg" alt=""></a>
                            </div>
                            <div class="it-blog-content">
                                <div class="it-blog-meta pb-25">
                                    <span>
                                        <i class="fa-light fa-user"></i>
                                        Sunilra smoth</span>
                                    <span>
                                        <i class="fa-light fa-calendar-days"></i>
                                        March 28, 2023</span>
                                </div>
                                <h4 class="it-blog-title pb-5"><a href="#">Lorem ipsum dolor sit amet,
                                        consectetur
                                        Adipiscing elit, sed do.</a></h4>
                                <a class="it-btn blue-bg" href="#">
                                    <span>
                                        read more
                                        <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                                stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- blog-area-end -->
    </main>

    <!-- Start Modal -->
    <Dialog v-model:visible="visible" modal header="Notices" :style="{ maxWidth: '90%' }"
        style="background-color: white; padding: 20px; overflow: auto;">
        <div class="dialog-content">
            <div class="interview">
                <ol class="link-list">
                    <li>
                        <a href="/documents/notice/9_institute-level-admission-notice-2026-27.pdf" target="_blank" rel="noopener noreferrer">
                            Institute level admission notice 2026-27
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/10_institute-level-admission-notice-for-bms-26-29.pdf" target="_blank" rel="noopener noreferrer">
                            Institute level admission notice for BMS 26-29
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/11_bms-provisional-merit-list-ay-2026-27.pdf" target="_blank" rel="noopener noreferrer">
                            BMS PROVISIONAL MERIT LIST AY. 2026-27
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/12_mms-provisional-merit-list-ay-2026-27.pdf" target="_blank" rel="noopener noreferrer">
                            MMS PROVISIONAL MERIT LIST AY. 2026-27
                        </a>
                    </li>

                    <li>
                        <a href="/documents/notice/5_brochure-mms-bms-2026-27.pdf" target="_blank" rel="noopener noreferrer">
                            BROCHURE  MMS & BMS 2026-27
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/8_institute-level-admission-to-mms-bms-institute-level-seats-vacant-seats-after-cap-advertisement.jpeg" target="_blank" rel="noopener noreferrer">
                            Institute level Admission to MMS & BMS Institute level seats & Vacant Seats after CAP Advertisement
                        </a>
                    </li>
                    <!--  -->
                    <li>
                        <a href="/documents/notice/1_first-merit-list-lateral-entry-mms-2026-27.pdf" target="_blank" rel="noopener noreferrer">
                            First Merit list - Lateral Entry - MMS 2026-27
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/2_lateral-entry-notice-for-direct-second-year-admission.pdf" target="_blank" rel="noopener noreferrer">
                            Lateral Entry Notice for Direct Second Year Admission
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/3_recruiters-that-visited-for-pioneer-batch-of-mms.pdf" target="_blank" rel="noopener noreferrer">
                            Recruiters that visited for pioneer batch of MMS
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/4_admission-announcement-mms-bms-aicte.pdf" target="_blank" rel="noopener noreferrer">
                            Admission Announcement for MMS & BMS (AICTE)
                        </a>
                    </li>
                    <li>
                        <a href="/documents/notice/5_second-merit-list-lateral-entry-mms-2026-27.pdf" target="_blank" rel="noopener noreferrer">
                            Second Merit List - Lateral entry - MMS 2026-27
                        </a>
                    </li>
                </ol>
            </div>
        </div>
    </Dialog>

</template>
<script>
import HomeBanner from "@/components/HomeBanner";
import Dialog from 'primevue/dialog';
export default {
    name: "HomePageView",
    data() {
        return {
            visible: true
        }
    },
    components: {
        HomeBanner,
        Dialog
    }
};
</script>

<style>
.dialog-content {
    padding: 20px;
    text-align: center;
    font-family: Arial, sans-serif;
}

.interview {
    padding: 10px;
}

/* Style the ordered list for left alignment and remove default styling */
.link-list {
    padding-left: 20px;
    /* Adds padding to the left for the numbers */
    list-style-type: decimal;
    /* Ensures the list is numbered */
    margin: 0;
    text-align: left;
    /* Left-align the list */
}

/* Optional: Style for each list item */
.link-list li {
    margin-bottom: 15px;
    /* Adds space between list items */
}

/* Optional: Style for the links */
.link-list a {
    text-decoration: none;
    color: #007BFF;
    font-size: 16px;
    transition: color 0.3s ease;
}

.link-list a:hover {
    color: #0056b3;
}
</style>